import React from "react";
import {
  Link,
} from "react-router-dom";

const MenuItem = ({ label, link, icon, active, onClick, iconClass } : any) => {
  return (
    <Link
      className={`w-full flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start border-l-4
      ${active ? 'text-gray-800' : 'text-gray-600' }
      ${active ? 'border-lime-500' : 'border-transparent' }
      ${!active && 'hover:text-gray-800' }
      `}
      to={link || '#'}
      onClick={onClick}
    >
      <span className={`${active && iconClass} text-left`}>
        {icon}
      </span>
      <span className='mx-2 text-sm font-normal'>
        {label}
      </span>
    </Link>
  );
}

export default MenuItem
